var map = {
	"./carre-bleu.png": "a959",
	"./carre-jaune.png": "666f",
	"./carre-rouge.png": "267c",
	"./rond-bleu.png": "885c",
	"./rond-jaune.png": "6a71",
	"./rond-rouge.png": "82ec",
	"./triangle-bleu.png": "5200",
	"./triangle-jaune.png": "3573",
	"./triangle-rouge.png": "d9ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c0c";